import { render, staticRenderFns } from "./Bestaetigt.vue?vue&type=template&id=07992630"
import script from "./Bestaetigt.vue?vue&type=script&lang=ts"
export * from "./Bestaetigt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports